/** English web app chrome. Other locales must provide the same keys. */
export const en = {
  appTitle: "intEHRgrator — Integration Workbench",
  copyPrompt: "Copy prompt",
  copyPromptTitle: "Copy AI prompt with files embedded",
  callAi: "Call AI",
  callAiTitle: "Call the configured AI with mapping tools (MCP / Agent API names)",
  aiMenuAria: "AI assistance",
  menuCopyPrompt: "Copy prompt",
  menuCallAi: "Call AI",
  menuAiCredentials: "Configure AI credentials…",
  menuEmbedFiles: "Embed files in prompt",
  menuAttachFiles: "Attach files in chat",
  menuBrowseUris: "Browse URIs (when available)",
  menuAttachOriginalTarget: "Attach original target",
  menuAttachOriginalTargetTitle: "Also send the raw target file (OPT / schema). Off: the compact slot tree only, much smaller.",
  menuAiLanguages: "Languages…",
  aiLanguagesTitle: "Languages",
  aiLanguagesIntro: "Which languages the source is in decides which target language the AI and the panes use first.",
  aiSourceLanguagesLabel: "Source languages (priority order)",
  aiSourceLanguagesDetected: "Empty = detected from the source: {langs}",
  aiSourceLanguagesNone: "Empty = detected from the source (nothing detected yet)",
  aiSourceLanguagesInvalid: "Unknown language code: {codes}",
  aiContextLanguagesLabel: "Target labels sent to the AI",
  aiContextMatched: "First target language + the ones the source uses",
  aiContextLang1: "First target language only (fewest tokens)",
  aiContextAll: "All target languages",
  aiLanguagesPreview: "Target languages: {order}. Sent to the AI: {ai}.",
  langWidgetTargetAria: "Language of the target labels",
  langWidgetSourceAria: "Language of the source descriptions",
  langWidgetTitle: "Shown in",
  langWidgetFollow: "Follow the source",
  langWidgetChosen: "your choice",
  langWidgetUnknown: "Not an ISO 639-1 language code: {code}",
  menuAiCopyHeading: "copy/paste for external AI chat",
  menuAiOwnHeading: "Your own AI",
  menuAiDesktopHeading: "Desktop",
  menuLocalMcp: "Local MCP server…",
  localMcpTitle: "Local MCP server",
  localMcpIntro:
    "Start or stop the server your IDE uses to edit this canvas. Copy the configuration into the IDE’s MCP settings. Keep this app open.",
  localMcpRunning: "Running — an IDE can connect",
  localMcpStopped: "Stopped — IDEs cannot change this canvas",
  localMcpStart: "Start",
  localMcpStop: "Stop",
  localMcpUrlLabel: "Agent API URL",
  localMcpTokenLabel: "Token",
  localMcpNoToken: "No token (loopback only)",
  localMcpConfigLabel: "IDE configuration (mcp.json)",
  localMcpCopy: "Copy configuration",
  localMcpCopied: "Configuration copied",
  localMcpUnavailable: "The desktop server did not answer.",
  menuFile: "File",
  menuAi: "AI",
  importAi: "Import AI suggestions",
  exampleSets: "Example Sets",
  exampleSetsTitle: "Load a complete example set (source, target, optional mapping) from catalog URIs",
  exampleSetsMenuAria: "Choose example set",
  functions: "Functions",
  functionsTitle: "Save, load, or contribute Blockly Functions; browse the GitHub Function library",
  newProject: "New Project",
  loadProject: "Load Project",
  saveAs: "Save as",
  exportProject: "Export Project",
  importProject: "Import Project",
  betterForm: "Open Better form",
  betterFormTitle: "The licensed renderer stays in this browser. Upload it in the viewer if it is missing.",
  help: "Help",
  helpTitle: "Tutorial and issue reporting",
  helpMenuAria: "Help menu",
  userTutorial: "User tutorial",
  reportBug: "Report a bug",
  requestFeature: "Request a feature",
  uiLanguageAria: "Application UI language",
  showSource: "Source",
  source: "Source",
  clickToMapAria: "Click-to-Map into Handlebars",
  clickToMapHtml:
    "Click a Source Schema or Example Instance node to map it into the selected Blockly block. If a Code text block (LANG = Handlebars) or a Handlebars text block is selected, the click inserts a VMS-Hbs {{path}} at the caret. Hold Shift for nested {{#with}} / {{#each}}. Otherwise Listening Mode fills the waiting Source query block.",
  slideSourceAway: "Slide Source away",
  handlebarsHint: "Handlebars insert ready — click a source node for {{path}}; Shift+click for nested #with/#each.",
  schema: "Schema",
  schemaFormatsAria: "Supported schema formats",
  schemaFormatsHtml:
    "Supported: JSON Schema, JSON or XML documents, XSD samples, and openEHR Web Template, Composition JSON, or a GitHub .t.json (archetypes fetched from the same repo).<br>Load from a local file, a URL, or ▾ → From GitHub template….",
  loadSchema: "Load Schema",
  schemaMenuAria: "More schema load options",
  examples: "Examples",
  exampleFormatsAria: "Supported example formats",
  exampleFormatsHtml:
    "Supported: JSON or XML instance files.<br>Load one file, a local folder, a GitHub folder (▾), or a single file from URL.",
  addExample: "+ Add Example",
  exampleMenuAria: "More example load options",
  mappingEditors: "Mapping Editors",
  undo: "Undo",
  redo: "Redo",
  expandAll: "Expand all",
  expandAllTitle: "Expand all nested blocks",
  collapseAll: "Collapse all",
  collapseAllTitle: "Collapse all nested blocks",
  expandChildren: "Expand children",
  collapseChildren: "Collapse children",
  useCodedText: "Use coded text (DV_CODED_TEXT)",
  usePlainText: "Use plain text (DV_TEXT)",
  followAgent: "Follow agent",
  followAgentTitle: "When enabled, pan the main canvas to blocks an agent just edited",
  openViewer: "Open viewer window",
  openViewerTitle: "Open viewer window: live canvas, agent legend, and attributed history timeline",
  downloadJson: "Download JSON",
  downloadWorkspaceTitle: "Download full Blockly workspace JSON (includes block coordinates and layout)",
  mappingViewsAria: "Mapping editor text views",
  mappingSpec: "Mapping Spec",
  specLayoutAria: "Mapping Spec view options",
  listView: "List view (all roots)",
  tabbedView: "Tabbed view (per root)",
  download: "Download",
  downloadSpecTitle: "Download the full Blockly workspace JSON",
  downloadSpecAria: "Download the full Blockly workspace JSON",
  upload: "Upload",
  uploadSpecTitle: "Upload a Blockly workspace JSON file",
  uploadSpecAria: "Upload a Blockly workspace JSON file",
  specEditorActionsAria: "Mapping Spec editor actions",
  codeFieldActionsAria: "Code field actions",
  searchCodeFieldTitle: "Search in this code field",
  copyCodeFieldTitle: "Copy this code field",
  searchSchemaTreeTitle: "Search in Source Schema",
  searchExampleTreeTitle: "Search in Example Instances",
  searchTargetSchemaTreeTitle: "Search in Target Schema",
  searchMappingCanvasTitle: "Search in Mapping canvas",
  paneFindPlaceholder: "Find",
  paneFindNext: "next",
  paneFindPrevious: "previous",
  paneFindMatchCase: "match case",
  paneFindRegexp: "regexp",
  paneFindByWord: "by word",
  paneFindClose: "close",
  paneFindCount: "{current} of {total}",
  paneFindNoMatches: "No matches",
  paneFindInvalidRegexp: "Invalid regexp",
  searchSpecTitle: "Search in mapping spec",
  searchSpecAria: "Search in mapping spec",
  copySpecTitle: "Copy mapping spec",
  copySpecAria: "Copy mapping spec",
  scriptEditorActionsAria: "Conversion script editor actions",
  searchScriptTitle: "Search in conversion script",
  searchScriptAria: "Search in conversion script",
  copyScriptTitle: "Copy conversion script",
  copyScriptAria: "Copy conversion script",
  downloadScriptAria: "Download conversion script",
  testEditorActionsAria: "Test output editor actions",
  searchTestTitle: "Search in test output",
  searchTestAria: "Search in test output",
  copyTestTitle: "Copy test output",
  copyTestAria: "Copy test output",
  downloadTestAria: "Download Conversion Test Run output",
  markWarned: "Mark warned optional",
  markWarnedTitle: "Mark unmapped optional scaffold trees that show a constraint warning",
  deleteMarked: "Delete marked",
  deleteMarkedTitle: "Delete checked nodes and their children from the canvas",
  undoHistoryHint: "Tip: Open canvas (observer) for the full agent timeline and attributed history.",
  undoLastEdit: "Undo last canvas edit.",
  redoLastEdit: "Redo canvas edit.",
  railTarget: "Target schema",
  railTargetTitle: "Target schema",
  railScripts: "Scripts",
  railScriptsTitle: "Generated conversion script(s)",
  railTest: "Test",
  railTestTitle: "Conversion Test Run(s)",
  targetPreviews: "Target & Previews",
  targetFormatsAria: "Supported target formats",
  targetFormatsHtml:
    "Supported: openEHR OPT/OPT2, Web Template, JSON Schema, XML Schema (XSD), ADL, free-form templates, or a GitHub .t.json (archetypes fetched from the same repo).<br>Choose a target and a default context map together. ▾ also offers file, URL, GitHub, and non-destructive refresh.",
  loadTarget: "Load target & default context map",
  loadTargetTitle: "Load a target and pick a default context map",
  targetMenuAria: "More target load options",
  modelLanguageAria: "Target model ontology language",
  scriptFormatsAria: "Conversion script formats",
  scriptFormatsHtml:
    "Mapping preview interprets the mapping without generating a script. Conversion scripts (so far): TypeScript, Java, Handlebars, XQuery, and Go Template. TypeScript, Handlebars, Go Template, and XQuery also run in Conversion Test Run. Java generates an Archie class but does not execute in the web app. The desktop app can add another language with --language-plugin. For openEHR targets, JSON vs XML instance chooses how XQuery serializes the composition.<br>Download on the script editor saves the generated script. Imports in that script open the helper or library source. The overlay Download on Conversion Test Run saves that instance.",
  mappingPreview: "Mapping preview",
  instance: "Instance",
  instanceTitle: "Desired openEHR instance shape. XQuery export and Test Run use this serialization.",
  jsonInstance: "JSON instance",
  xmlInstance: "XML instance",
  slideTargetAway: "Slide Target & Previews away",
  tabTargetSchema: "Target schema",
  tabScripts: "Generated conversion script(s)",
  tabTest: "Conversion Test Run(s)",
  generatedScripts: "Generated conversion script(s)",
  downloadScriptTitle: "Download conversion script",
  testRuns: "Conversion Test Run(s)",
  validateAs: "Validate as",
  validateTitle: "ehrtslib JSON deserializer preset for template validation",
  hybrid: "Hybrid (lenient)",
  defaultMode: "Default",
  compact: "Compact",
  canonicalStrict: "Canonical strict",
  terse: "Terse",
  runTest: "Run Test",
  autoplay: "▶ Auto-run",
  pause: "⏸ Pause",
  pauseAutoRunTitle: "Auto-run is on: all test files re-run shortly after each change. Pause it on slow computers.",
  resumeAutoRunTitle: "Auto-run is paused. Turn it back on to re-run all test files after each change, or use Run Test.",
  downloadTestTitle: "Download Conversion Test Run output",
  ready: "Ready",
  loadSchemaEmpty: "Load a schema file.",
  selectExampleTab: "Select an example tab.",
  addExamplesEmpty: 'Add example instance(s) to enable "Conversion Test Run(s)" in Target & Previews',
  loadTargetEmpty: "Load a target schema or template.",
  statusNoTarget: "No target",
  statusTarget: "Target: {id}",
  statusScript: "Script: {name}",
  statusNoExample: "No example",
  statusExample: "Example: {name}",
  statusUnmapped: "{n} unmapped mandatory",
  unsavedChanges: "unsaved changes",
  autosavedAt: "autosaved at {time}",
  functionsIntroHtml:
    "Save a Blockly Function (definition + Decision tables) to disk, load one into this mapping, or browse the GitHub Function library. Contribute files a review issue — it does not auto-merge.",
  onThisCanvas: "On this canvas",
  loadFromDisk: "Load from disk…",
  functionLibrary: "Function library",
  catalogUrl: "Catalog URL",
  loadCatalog: "Load catalog",
  close: "Close",
  nameInUse: "Name already in use",
  cancel: "Cancel",
  replace: "Replace",
  rename: "Rename",
  contributeTitle: "Contribute Function",
  contributeIntroHtml:
    "Opens a GitHub issue on <code>regionstockholm/intehrgrator</code> with your description and the Function definition. Maintainers review by hand.",
  functionName: "Function:",
  descriptionRequired: "Description (required)",
  contributePlaceholder: "What it returns, locale, Decision table, parameters…",
  needGithubHtml:
    'Need a GitHub account? <a id="function-contribute-signup" href="https://github.com/signup" target="_blank" rel="noopener noreferrer">Create an account</a> or <a id="function-contribute-login" href="https://github.com/login" target="_blank" rel="noopener noreferrer">log in</a>, then submit.',
  openGithubIssue: "Open GitHub issue",
  saveAsIntro: "Save the current workspace under a name you can load later.",
  projectName: "Project name",
  projectNamePlaceholder: "My integration project",
  save: "Save",
  loadProjectTitle: "Load project",
  loadProjectIntro: "Select a saved workspace. Loading replaces the current project.",
  loadFromUrl: "Load from URL",
  loadUrlHint: "Paste an https URL. GitHub file pages are converted to raw content.",
  urlLabel: "URL",
  recentUrls: "Recent URLs",
  load: "Load",
  jointTitle: "Load target & default context map",
  jointIntroHtml:
    "Pick a target and a default context map together. Confirm scaffolds the <strong>Template Skeleton</strong> and <strong>Default point</strong>s. <strong>New</strong> loads the target into the Target schema tab only so you can pull chips and values, then Apply on the canvas block.",
  targetLegend: "Target",
  noTargetYet: "No target selected yet.",
  fromFile: "From file…",
  useLoadedTarget: "Use loaded target",
  targetUrl: "Target URL",
  fetchUrl: "Fetch URL",
  mapLegend: "Default context map",
  factoryMapHtml: "openEHR factory (<code>defaults_openEHR_1</code>)",
  keepMap: "Keep the map already on the canvas",
  newMap: "New (empty) — Target schema first, then Apply",
  browsedFile: "Browsed file",
  browseMap: "Browse map file…",
  loadAndScaffold: "Load & scaffold",
  loadIntoSchema: "Load into Target schema",
  refreshReport: "Refresh report",
  copyMergePrompt: "Copy merge prompt",
  aiCredentialsTitle: "AI credentials",
  aiCredentialsIntroHtml:
    'Optional OpenAI-compatible chat endpoint so <strong>AI chat</strong> can map from the web app. Credentials stay in this browser only — not in the Project Bundle. <strong>AI chat</strong> can use the same mapping tools as MCP / the HTTP Agent API (<code>map_slot</code>, <code>import_suggestions</code>, <code>run_test</code>, …). An AI-assisted IDE with local MCP remains a separate, fully valid path. Step-by-step key pages: <a href="https://github.com/regionstockholm/intehrgrator/blob/main/docs/AI_CREDENTIALS.md" target="_blank" rel="noopener noreferrer" id="ai-credentials-guide">AI chat credentials</a>.',
  provider: "Provider",
  customEndpoint: "Custom OpenAI-compatible endpoint",
  getApiKey: "Get an API key",
  providerDocs: "Provider docs",
  endpoint: "Endpoint",
  apiKey: "API key",
  model: "Model",
  clear: "Clear",
  defaultsTitle: "Default context map",
  defaultsIntro: "Load a saved map, browse a file or URL, download the unique default context map, or save the current canvas map under a name.",
  browseFile: "Browse file…",
  loadUrlBtn: "Load URL",
  downloadFile: "Download file…",
  saveAsEllipsis: "Save as…",
  saveDefaultsTitle: "Save default context mapping as",
  saveDefaultsIntro: "Store the current default context mapping under a name you can pick later.",
  nameLabel: "Name",
  hardcodeTitle: "Hardcode default context mapping entry",
  hardcodeIntroHtml:
    "Choose a map key to <strong>inline</strong> on the canvas. Every <code>get defaults key …</code> lookup for that key is replaced with a copy of the value from this default context mapping. After that, those slots no longer read the convert-time <code>defaults</code> argument — they use the hardcoded block instead. The default context mapping itself is left unchanged so you can hardcode other keys later or keep the entry for remaining lookups.",
  importAiTitle: "Import AI suggestions",
  importAiIntroHtml:
    "Paste the JSON from the AI chat (a raw object or an <code>intehrgrator-suggestions</code> fence). Import validates against the suggestion JSON Schema; errors stay visible here and can be copied back to the AI.",
  suggestions: "Suggestions",
  pasteClipboard: "Paste clipboard",
  copyErrorsForAi: "Copy errors for AI",
  copied: "Copied",
  importAction: "Import",
  notRecommended: "Not on the recommended version",
  bleedingEdgeHtml:
    'Prefer to experiment? The bleeding-edge build (updated on every change to <code>main</code>) is always at <a id="recommended-version-bleeding-edge-link" href="#">the site root</a>.',
  newHereHtml:
    'New here? Read the <a id="recommended-version-tutorial-link" href="#">tutorial</a> or the <a id="recommended-version-readme-link" href="#">README</a>.',
  dontShowAgain: "Don't show this again for this version",
  dismiss: "Dismiss",
  defaultsBlockAria: "About the default context map",
  defaultsBlockHtml:
    "<strong>Default context map</strong> is the unique canvas table you author here. At <em>convert time</em>, generated Conversion Scripts receive it as a <code>defaults</code> argument keyed by <strong>runtime key</strong> (<code>language</code>, <code>facility</code>, …). <code>maps_get(\"defaults\", runtimeKey)</code> looks those up. Runtime code can merge that bag with per-message values, other named maps, and Sheet grids — the canvas map is the reusable baseline, not literals baked into every slot.<br><strong>Scaffold targets</strong> (chips) are authoring-only RM paths, not convert-time keys: <code>Class.attribute</code> (e.g. <code>COMPOSITION.composer</code>, <code>EVENT_CONTEXT.health_care_facility</code>), ancestor paths, and wildcards (<code>*.language</code> lights every language slot). A more specific chip wins when several match the same slot. Empty chips → a runtime-only key that lights nothing. Extra keys stay available for Map lookups even if they do not light a slot.<br>Confirm, <strong>Apply default context map</strong>, or a later target refresh join <strong>Default point</strong>s. Value edits are live in Test Run. A slot already mapped from source is not replaced.<br>The folder opens load/save: pick a map saved in this browser, browse a JSON file, load a URL, save a named copy, or download the current map as JSON you can upload again later.",
  decisionBlockAria: "About decision tables",
  decisionBlockHtml:
    "<strong>Decision table</strong> is a named rule grid in the Tables &amp; Sheets tab: condition columns (equality, don't-care <code>—</code>) and output columns (plain values or VMS-Mustache snippets). The grid owns column names and types; this block’s inputs Map keys stay in sync.<br>Plug an inputs Map on the right (keys = condition headers). The output dropdown returns one typed column (🔤 string, 🔢 number, ✓ boolean), or <em>all outputs</em> as a Map (↦). Switching that type may unplug the block; canvas undo/redo restores it.<br>Hit policy (FIRST / UNIQUE / COLLECT) is on the Tables &amp; Sheets tab. Flatten nested sources into the inputs Map (or via variables) before eval.",
  fromUrl: "From URL…",
  refreshFromFile: "Refresh from file…",
  refreshFromUrl: "Refresh from URL…",
  noRecentUrls: "No recent URLs yet.",
  removeFromHistory: "Remove {url} from history",
  enterUrl: "Enter a URL.",
  refreshKindFromUrl: "Refresh {kind} from URL",
  refreshUrlHint: "Reload this file from a URL without wiping canvas mappings. Warnings list slots or paths that may no longer fit.",
  kindSchema: "schema",
  kindExample: "example",
  kindTarget: "target",
  kindSource: "source",
  fromLocalFolder: "From local folder…",
  fromGithubFolder: "From GitHub folder…",
  fromGithubTemplate: "From GitHub template…",
  loadSchemaFromUrl: "Load schema from URL",
  loadSchemaUrlHint: "JSON, XML, XSD, or a GitHub .t.json template (archetypes are fetched from the same repo). GitHub file pages are converted to raw content.",
  recentSchemaUrls: "Recent schema URLs",
  githubTemplateTitle: "Load openEHR template from GitHub",
  githubTemplateHint: "Paste a GitHub blob or raw URL to a Better .t.json (or .adl / .opt). Dependent archetypes are pulled from the same repository branch.",
  githubTemplateOpenTitle: "Open openEHR template from GitHub",
  addExampleFromUrl: "Add example from URL",
  addExampleUrlHint: "JSON or XML instance. GitHub file pages are converted to raw content.",
  recentExampleUrls: "Recent example URLs",
  githubFolderTitle: "Add examples from GitHub folder",
  githubFolderHint: "Paste a GitHub tree URL to a folder. All JSON and XML files under that path are loaded.",
  loadTargetFromUrl: "Load target from URL",
  loadTargetUrlHint: "OPT, Web Template, JSON Schema, or a GitHub .t.json. GitHub file pages are converted to raw content.",
  recentTargetUrls: "Recent target URLs",
  loadingCatalog: "Loading catalog…",
  exampleSetsHeading: "Example sets",
  noExampleSets: "No example sets in catalog",
  catalog: "Catalog",
  bundledCatalog: "Bundled dummy catalog",
  ehrtslibCatalog: "ehrtslib catalog (GitHub)…",
  loadCatalogFromUrl: "Load catalog from URL…",
  catalogUrlPrompt: "Example-set catalog JSON URL",
  confirmLoadExampleSet: "Load this example set? The current workspace will be replaced. Unsaved changes may be lost.",
  confirmNewProject: "Start a new project? The current workspace will be cleared. Unsaved changes may be lost.",
  confirmNewEmpty: "Start a new empty project?",
  confirmLoadProject: "Load this project? The current workspace will be replaced.",
  noSavedProjects: "No saved projects yet. Use Save as or wait for autosave.",
  lastAutosave: "Last autosave",
  savedProject: "Saved project",
  defaultsUnavailable: "Defaults catalog unavailable: {detail}",
  noSavedMaps: "No saved default context mappings yet. Use Save as, Download, Browse file, or a URL.",
  savedMap: "Saved map",
  noHardcodeEntries: "The default context mapping has no entries to hardcode yet.",
  selectedFile: "Selected: {name}",
  usingLoaded: "Using loaded: {name}",
  fetchedFile: "Fetched: {name}",
  browsedFileLabel: "Browsed file: {name}",
  pasteTargetUrl: "Paste a target URL first.",
  popupBlockedSvg: "Popup blocked — downloaded SVG instead.",
  popupBlockedEmpty: "Popup blocked and the canvas is empty.",
  openedObserver: "Opened agent observer / canvas snapshot.",
  betterPopupBlocked: "Could not open the Better form viewer. Allow popups for this site.",
  schemaMismatch: "Schema mismatch:",
  conversionFailed: "Conversion failed:",
  templateValidation: "Template validation:",
  noWorkspace: "No Blockly workspace",
  noFunctionsOnCanvas: "No Functions on the canvas. Extract to function, or load from the library.",
  contribute: "Contribute",
  loadCatalogBrowse: "Load the catalog to browse curated Functions.",
  catalogNoFunctions: "Catalog has no Functions.",
  loadingLibrary: "Loading Function library…",
  fnReturnsValue: "{sig} → value",
  pasteJsonFirst: "Paste the AI JSON (or an intehrgrator-suggestions fence) first",
  clipboardEmpty: "Clipboard is empty or not readable in this browser",
  noMatches: "No matches",
  searchPlaceholder: "Search…",
  filterList: "Filter list",
  historyTimeline: "History timeline",
  historyIntro: "Scrub to preview; Undo to here takes back later changes (the history keeps them). Patch undo returns intehrgrator-suggestions v2 JSON.",
  seqLabel: "Seq",
  previewAtSeq: "Preview at seq",
  rollbackHere: "Undo to here",
  copyPatchUndo: "Copy patch-undo prompt",
  timelineDesktopOnly: "Agent API timeline is only available in the desktop app.",
  timelineUnavailable: "Agent API unavailable — timeline idle.",
  noHistoryYet: "No history yet.",
  selectHistoryPoint: "Select a history point.",
  downloadDiscardedConfirm: "Download the discarded branch (.intehrgrator) before continuing?",
  noBundleExport: "No bundle data to export for discarded branch.",
  downloadedDiscarded: "Downloaded discarded branch.",
  agentsHeading: "Agents",
  projectLoaded: "Project loaded",
  newProjectStatus: "New project",
  projectNotFound: "Project not found",
  projectImported: "Project imported",
  restoredMapping: "Restored previous mapping",
  blocklyMustBeObject: "Blockly JSON must be an object",
  exampleDropJsonXml: "Example drop: JSON or XML files only",
  listeningSourceQuery: "Listening for source path → source query",
  appliedDefaults: "Applied default context map",
  refreshPromptCopied: "Refresh merge prompt copied",
  callingAi: "Calling AI…",
  providerRejectedTools: "Provider rejected mapping tools; retrying suggestions JSON…",
  aiCredentialsCleared: "AI credentials cleared",
  aiCredentialsSaved: "AI credentials saved in this browser",
  saveAiOrCopy: "Save AI credentials to AI chat, or use Copy prompt.",
  loadTargetFirst: "Load a target into Target schema first, then Apply default context map.",
  targetNodeMissing: "That Target schema node is not in the loaded target.",
  dropLeafHint: "Drop a leaf onto scaffold-target chips, a subtree onto a value socket, or onto empty canvas.",
  emptyMapReady: "Empty default context map ready — pull from Target schema, then Apply.",
  pickTargetFirst: "Pick a target file or URL first.",
  aiNotesHeading: "Notes",
  aiQuestionsHeading: "Questions",
  aiSuggestionNotes: "Notes on suggestions",
  aiConfidenceTitle: "AI-estimated chance this mapping is correct: {pct}%",
  aiMarkReviewed: "Mark as reviewed",
  aiReviewComment: "AI suggestion — {conf}{note}\nEdit the block or right-click → Mark as reviewed to clear.",
  aiReviewConfidence: "{pct}% confidence",
  aiAnswerQuestion: "Answer",
  aiAnswerQuestionTitle: "Quote this question in the chat input and type your own answer",
  aiAnswerWithOption: "Quote this question with this answer in the chat input (edit before sending)",
  aiQuestionOptions: "Suggested answers",
  aiOptionRecommended: "recommended",
  aiAnswerInChatTitle: "Answer this question in AI chat",
  aiFetchModels: "Connect & fetch models",
  aiSelectProvider: "Select provider…",
  aiSelectModel: "Select model",
  aiModelOther: "Other… (type the model id below)",
  aiModelsNotListedHint: "This provider may not list models; type the model id instead.",
  aiForgetKey: "Forget key for this provider",
  aiForgetKeyTitle: "Remove this provider's API key from this browser (endpoint and model are kept)",
  aiKeyForgotten: "API key for {provider} removed from this browser",
  aiClearAllProviders: "Clear all",
  aiForgetKeyConfirm: "Remove the saved API key for {provider} from this browser? Chat history and stored prompts are kept.",
  aiClearAllProvidersConfirm: "Forget the saved AI settings for all providers in this browser?",
  aiFetchingModels: "Connecting…",
  aiModelPickerLabel: "Fetched models",
  aiModelPickerPlaceholder: "Pick one of {count} models…",
  aiModelsFound: "Connected — {count} models. Pick one or keep typing your own.",
  aiModelsDesktopHint: "The desktop app forwards this call (no CORS); check the endpoint and that the server is running.",
  aiModelsCorsHint: "If the endpoint and network are fine, the browser likely blocked the call (CORS). Use the desktop app, which forwards it, or enable CORS on a local server (Ollama: OLLAMA_ORIGINS; LM Studio: Enable CORS).",
  aiModelsAuthHint: "Check the API key (and that it is allowed to list models).",
  corsCallAiHint: "Browser CORS often blocks cloud providers from GitHub Pages. Use the desktop app (it forwards AI chat), enable CORS on a local server (Ollama / LM Studio), or use Copy prompt.",
  savedAs: 'Saved as "{name}"',
  loadedSchema: "Loaded schema {name}",
  loadedBlockly: "Loaded Blockly mapping {name}",
  loadedTargetIntoSchema: "Loaded {format} target {id} into Target schema (no product scaffold yet)",
  loadedTarget: "Loaded {format} target {id}",
  loadedFunctionLibrary: "Loaded Function library ({n})",
  loadedFunction: "Loaded Function {name}",
  loadedExampleCatalog: "Loaded example-set catalog ({n} {sets})",
  setSingular: "set",
  setPlural: "sets",
  loadedExampleSet: 'Loaded example set "{name}"',
  exampleSetFailed: 'Example set "{name}" failed: {detail}',
  addedExample: "Added example {name}",
  addedExampleMismatch: "Added example {name} with {n} schema {mismatch}",
  mismatchSingular: "mismatch",
  mismatchPlural: "mismatches",
  addedExamples: "Added {n} examples",
  addedExamplesMismatch: "Added {n} examples with {m} schema {mismatch}",
  aiPromptCopied: "AI prompt copied ({delivery})",
  listeningSlot: "Listening for source path → {slot}",
  mappedWhat: "Mapped {what}",
  mappedSourceQuery: "Mapped source query {xpath}",
  importSummary: "Import: {applied} applied, {loops} loops, {skipped} skipped, {errors} errors{schema}",
  importSchemaNote: ", {n} schema",
  importFailed: "Import failed: {detail}",
  targetLoadFailed: "Target load failed: {detail}",
  exampleLoadFailed: "Example load failed: {detail}",
  exampleFolderFailed: "Example folder load failed: {detail}",
  functionCatalogFailed: "Function library catalog failed: {detail}",
  exampleCatalogFailed: "Example-set catalog failed: {detail}",
  blocklyParseFailed: "Blockly JSON parse failed: {detail}",
  couldNotLoad: "Could not load {name}: {detail}",
  autosaveFailed: "Autosave failed: {detail}",
  modelLanguageStatus: "Model language: {language}",
  refreshedClean: "Refreshed {kind} {name} with no mapping conflicts.",
  refreshedWithWarnings: "Refreshed {kind} {previous} → {next}",
  warningCount: "{n} {warnings}:",
  warningSingular: "warning",
  warningPlural: "warnings",
  loadedGithubTemplate: "Loaded GitHub template {id} ({n} files){extra}",
  loadedGithubSchema: "Loaded GitHub schema {id} ({n} files){extra}",
  warningsParen: " ({n} warnings)",
  callAiFailed: "Call AI failed: {detail}",
  scaffoldTarget: "Scaffold target {path} (click the chip to toggle *.)",
  nestedOnMap: "Nested {label} on the default context map",
  addedMapEntry: "Added entry {key} ({path}) at row {row}",
  addedFromTarget: "Added {label} from Target schema",
  addedSource: "Added source {xpath}",
  taskLoadGithub: "Load GitHub clinical model",
  taskLoadAndScaffold: "Load and scaffold target",
  taskLoadExampleSet: "Load example set",
  taskLoadTarget: "Load target",
  taskLoadSchema: "Load source schema",
  taskLoadMapping: "Load mapping",
  taskLoadSheets: "Load sheets",
  taskLoadDefaults: "Load defaults map",
  taskParseUrl: "Parse GitHub URL",
  taskIndexTree: "List repository files",
  taskFetchFiles: "Fetch clinical model files",
  taskParseModels: "Parse templates and archetypes",
  taskResolveOpt: "Resolve operational template",
  taskScaffold: "Scaffold Template Skeleton",
  taskGenerate: "Generate conversion script",
  taskLoadExampleN: "Load example {n}",
  appDescription: "intEHRgrator — visual integration workbench for mapping source data to openEHR",
  loadedColon: "Loaded: {name}",
  savedColon: "Saved: {name}",
  noMappingConflicts: "No mapping conflicts.",
  refreshReportLine: "{kind} {previous} → {next}",
  refreshWarningCount: "{n} warning(s):",
  hardcodedLookups: "Hardcoded “{key}” into {n} {lookups}",
  lookupSingular: "lookup",
  lookupPlural: "lookups",
  noDefaultsLookups: "No maps_get(\"defaults\", \"{key}\") lookups found on the canvas",
  callAiResult: "Call AI: {applied} applied · {errors} errors{extra}",
  functionLibraryCount: "Function library: {n} {functions}",
  functionSingular: "Function",
  functionPlural: "Functions",
  renamedFromParen: " (renamed from {name})",
  savedBundle: "Saved {name}",
  descriptionForFunction: "Description for Function \"{name}\" (optional):",
  clashExist: "{bits} already exist. Rename keeps both (default). Replace overwrites the existing definition.",
  functionQuoted: "Function \"{name}\"",
  decisionQuoted: "Decision table \"{name}\"",
  andWord: "and",
  openedContributionIssue: "Opened contribution issue for {name}",
  openedGithubForm: "Opened GitHub new-issue form for {name}",
  entrySummary: "{description} Parameters: {params}. Decision tables: {tables}.",
  recommendedFrozen: "You are using intEHRgrator {current}, which is not the recommended end-user version ({recommended}).",
  recommendedBleeding: "You are using the bleeding-edge build (updated on every change to main), not the recommended stable version ({recommended}).",
  goToRecommended: "Go to recommended version ({tag})",
  previewingSeq: "Previewing seq {n}…",
  previewLoadedSeq: "Preview loaded for seq {n} (read-only; main canvas unchanged).",
  rollbackAsk: "Rollback to seq {seq}?\n\n{n} later entries will be discarded.\n\nDownload the discarded branch (.intehrgrator) before continuing?",
  confirmRollback: "Take back every change after seq {seq}?",
  rolledBackSeq: "Rolled back to seq {n}. Main canvas will sync.",
  patchPromptCopied: "Patch prompt copied (intehrgrator-suggestions v2). Apply via import_suggestions.",
  noAgentsYet: "No agents connected yet.",
  optionalAttributes: "Optional attributes…",
  openViewerMenu: "Open viewer window…",
  openInAiChat: "Open in AI chat",
  aiChat: "AI chat",
  aiChatCollapse: "Collapse AI chat",
  aiChatExpand: "Expand AI chat",
  aiChatClear: "Clear history",
  aiChatClearTitle: "Clear chat history",
  aiChatClearedApi: "History cleared. A fresh context starts: your next message sends the full project context again.",
  aiChatClearedPaste:
    "History cleared. Also start a new chat in your external AI: the next copied prompt contains the full project context again — paste it there.",
  aiChatHelpAria: "About the AI chat controls",
  aiChatHelpPasteHtml:
    "<strong>AI chat — copy &amp; paste mode</strong> (no AI credentials)<br>" +
    "Write a message and use <strong>Copy prompt</strong>, paste it into your external AI, then <strong>Import AI answer…</strong>.<br>" +
    "<strong>Prompts ▾</strong> stored prompts: insert, save or remove reusable texts.<br>" +
    "<strong>Trash</strong> clears this project's chat history. Then also start a new chat in your external AI and paste the full prompt again: the next copied prompt automatically includes the full project context.<br>" +
    "<strong>Toggle</strong> (right) collapses or expands the chat; the state is remembered.<br>" +
    "<strong>Context chips</strong>: right-click source nodes, target nodes or blocks → <em>Add to AI chat</em>.<br>" +
    "<strong>Notes / Questions</strong> from the AI show in a yellow box; <em>Answer</em> quotes a question into the input. A <strong>NN%</strong> badge and dashed outline mark low-confidence suggestions on blocks; edit or right-click → <em>Mark as reviewed</em> to clear.<br>" +
    "<strong>AI credentials</strong> (menu <em>AI → Configure AI credentials…</em>) connect an API so the chat can send directly.",
  aiChatHelpApiHtml:
    "<strong>AI chat — API mode</strong><br>" +
    "<strong>Send</strong> talks to your configured AI. The first message carries a compact project context (slot manifest, source paths, example list; the AI fetches more with its tools); later ones only your text and new context chips.<br>" +
    "<strong>Prompts ▾</strong> stored prompts: insert, save or remove reusable texts.<br>" +
    "<strong>Streaming</strong>: the answer and any model reasoning stream in as they arrive; each mapping the AI applies through its mapping tools shows as a short ✓ line. Changes land on the canvas right away; <em>Revert last AI turn</em> undoes the whole turn.<br>" +
    "<strong>Stop</strong> (or Esc in the input) ends a run that seems to go wrong; mappings made before Stop stay and can be reverted.<br>" +
    "<strong>Trash</strong> clears this project's chat history and starts a fresh context: the next message resends the full project context.<br>" +
    "<strong>Toggle</strong> (right) collapses or expands the chat; the state is remembered.<br>" +
    "<strong>Context chips</strong>: right-click source nodes, target nodes or blocks → <em>Add to AI chat</em>.<br>" +
    "<strong>Notes / Questions</strong> from the AI show in a yellow box; <em>Answer</em> quotes a question into the input. A <strong>NN%</strong> badge and dashed outline mark low-confidence suggestions on blocks; edit or right-click → <em>Mark as reviewed</em> to clear.<br>" +
    "<strong>AI credentials</strong> (menu <em>AI → Configure AI credentials…</em>) change provider, key or model.",
  aiChatClearConfirm: "Clear the AI chat history for this project?",
  aiChatStoredPrompts: "Stored prompts",
  aiChatStoredPromptsShort: "Prompts",
  aiChatAddPromptFile: "Add stored prompt from file…",
  aiChatAddPromptUrl: "Add stored prompt from URL…",
  aiChatExportPrompts: "Export stored prompts",
  aiChatPromptUrlAsk: "URL of a .md, .txt or .json prompt file:",
  aiChatRemovePrompt: "Remove stored prompt",
  aiChatRemovePromptConfirm: "Remove stored prompt \"{name}\"?",
  aiChatPromptsAdded: "{count} stored prompt(s) added",
  aiChatPromptLoadFailed: "Could not add stored prompt: {detail}",
  aiChatPlaceholder: "Ask about the mapping. Right-click source nodes, target nodes or blocks → Add to AI chat to reference them.",
  aiChatSend: "Send",
  aiChatSending: "Waiting for AI…",
  aiChatStreaming: "AI is answering…",
  aiChatRunningTool: "Running {name}…",
  aiChatReasoning: "Model reasoning (latest part)",
  aiChatStop: "Stop",
  aiChatStopTitle: "Stop the AI run (Esc). Mappings made so far stay; Undo takes them back.",
  aiChatStopped: "Stopped. Mappings made before Stop stay on the canvas; one Undo takes back the whole turn.",
  aiChatHistoryTrimmed:
    "Older chat turns were dropped to keep the request within {limit} tokens (the API resends the whole chat every step); this message re-attaches the project context.",
  aiChatHistoryFull:
    "Nothing sent: this chat's history is about {tokens} tokens, above the {limit} limit for this model, and the whole history goes with every request. How do you want to go on?",
  aiChatHistoryTrimChoice: "Continue with trimmed history",
  aiChatHistoryRecapChoice: "Start new chat with summary",
  aiChatHistoryCancelChoice: "Cancel",
  aiChatHistoryRecapStarted:
    "New chat started. A recap of the earlier chat (your messages, the answers and the mappings) goes with your message, together with the project context.",
  aiChatHistoryCancelled: "Not sent. Your message is still in the box.",
  aiChatStorageTrimmed:
    "This chat is larger than the browser stores ({limit} characters). This page keeps the whole chat, but after a reload only the newest turns are left.",
  historyTitle: "History",
  historyOpenTitle: "History: who changed what (you, AI chat, MCP agents), with Undo to here and Revert",
  historyClose: "Close history",
  historyIntroPanel: "Newest first. Undo to here takes back every later change. Revert takes back only that change, as a new change; slots changed later stay.",
  historyYou: "You",
  historyAiChat: "AI chat",
  historyPasted: "pasted",
  historyEmpty: "No changes yet.",
  historyUndone: "undone",
  historyUndoTo: "Undo to here",
  historyUndoToTitle: "Take back every change after this one",
  historyRevert: "Revert",
  historyRevertTitle: "Take back only this change, as a new change at the end; changes made later stay",
  historyRevertDone: "Revert: took back #{seq} by {author} ({count} slot(s)).",
  historyRevertSkipped: "Skipped, changed later: {slots}.",
  historyRevertNotReverted: "Not reverted: {parts}.",
  historyRevertNothing: "Revert #{seq}: nothing to take back; every slot it changed was changed again later.",
  aiAuthorTitle: "Written by {author}; the mark goes when you change this mapping",
  leaseTitle: "Leased by {agent} until {time}: other MCP agents cannot change {what}. You are asked first.",
  leaseWhatSlot: "this slot",
  leaseWhatSubtree: "anything in this subtree",
  leaseSubtree: "subtree",
  leasesChip: "Leases",
  leasesChipTitle: "MCP agents' leases right now (who works on what). Click to show the next one.",
  leaseWarningTitle: "An agent is working on this",
  leaseWarningIntro:
    "{agent} leased what you just changed. Your change is on screen but not saved yet. Edit anyway and you win: if the agent writes there too, its change is not applied. You are not asked again about this lease.",
  leaseWarningEndsIn: "lease ends in {time}",
  leaseWarningEnded: "lease ended",
  leaseWarningEdit: "Edit anyway",
  leaseWarningCancel: "Cancel",
  leaseWarningEdited: "You changed {slots}, which {agent} leases. If {agent} writes there too, your change stays.",
  leaseWarningCancelled: "Your change was taken back: {agent} leases {slots}.",
  leaseWarningExpired: "{agent}'s lease ended; your change to {slots} is saved.",
  leaseHumanWins: "{agent}'s change to {slots} was not applied: you changed it during {agent}'s lease (you win).",
  undoneBy: "Undo: took back a change by {author}",
  anAgent: "an agent",
  redoneBy: "Redo: restored a change by {author}",
  agentChangeOverwritten:
    "Your change replaced an agent change made at the same moment ({agent}: {summary}). It is still in the history.",
  aiChatToolCall: "Tool: {name}",
  aiChatToolCalls: "{count} tool call(s)",
  aiChatNoCredentials: "No AI credentials are configured for this browser. Configure them to chat directly, or use copy & paste with any AI chat.",
  aiChatConfigure: "Configure AI credentials…",
  aiChatCopyPrompt: "Copy prompt",
  aiChatCopyPromptTitle: "Copy the full prompt (project context, your text and chips) for an external AI chat",
  aiChatImportAnswer: "Import AI answer…",
  aiChatPromptCopied: "Prompt copied. Paste it into your AI chat, then Import AI answer.",
  aiChatTruncated:
    "The answer was cut off at the model's output-token limit, so nothing could be imported. Ask again for fewer slots at a time (for example one loop), or send \"continue\".",
  aiChatStepLimit:
    "Stopped after {steps} tool steps (the guard against a model that loops); it was not finished. Send \"continue\" to let it go on.",
  aiChatBudgetReached:
    "Paused: this chat used {used} of its {budget} token budget. Raise the budget to go on; the model continues where it stopped.",
  aiChatBudgetRaise: "Raise budget to {budget} and continue",
  aiChatBudgetWarn: "This chat has used {percent} % of its {budget} token budget ({used}).",
  aiUsageTitle: "Token use (click for details, budget and context window)",
  aiUsageThisTurn: "This turn",
  aiUsageThisChat: "This chat",
  aiUsageLine: "{label}: {input} in{cached} · {output} out · {requests} request(s)",
  aiUsageLineNone: "{label}: no requests yet",
  aiUsageCached: " ({cached} cached)",
  aiUsageEstimatedMark: "(estimate: the provider reported no usage)",
  aiUsageContext: "Context: {used} of {window} tokens ({percent} %)",
  aiUsageContextUnknown: "Context window unknown for this model: set it below to show the ring.",
  aiUsageBudgetLine: "Budget: {used} of {budget} ({percent} %)",
  aiUsageBudgetLabel: "Token budget per chat",
  aiUsageBudgetHint: "none, e.g. 2M",
  aiUsageWindowLabel: "Context window of {model}",
  aiUsageWindowKnown: "{tokens} (known)",
  aiUsageWindowUnknownHint: "unknown, e.g. 128k",
  aiUsageHelp:
    "Every step sends the whole chat again (the API keeps no session), so input grows with the chat; providers with prompt caching bill the repeated part cheaper. The budget counts input + output tokens of this chat until Clear history: a warning at 80 %, a pause at 100 %.",
  aiUsageSave: "Save",
  aiUsageClose: "Close",
  aiChatToolsFallback:
    "The provider rejected the mapping tools, so this answer was requested as suggestions JSON and applied directly (Revert last AI turn undoes it).",
  aiChatEmpty: "No messages yet.",
  addToAiChat: "Add to AI chat",
  aiChatChipRemove: "Remove",
  aiChatDismissNotice: "Hide this notice until AI chat is opened again",
  aiChatCopyMenuAria: "More copy/paste options",
  aiChatResizeInput: "Drag to resize the message box (↑/↓ keys also work)",
} as const;

export type ChromeMessages = { [K in keyof typeof en]: string };
